import '@cdm/quickenloans-library/lib/index.css';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { DesignSystemProvider } from '@quickenloans-ui-suite/design-system';
import { onRouteUpdate as onRouteUpdateFn } from './gatsby-apis/onRouteUpdate';
import './src/StyleGuide/styles/global.qld.scss';
import './src/StyleGuide/styles/global.scss';
import './src/StyleGuide/styles/global.typography.scss';
// import { VideoProvider } from './src/context/videoContext';
import 'core-js/features/array/at';
import 'core-js/features/string/at';

export const wrapRootElement = ({ element }) => (
  // TODO: fix the video provider, is failing due to the window object not being available in SSR
  // <VideoProvider>
  <CookiesProvider>
      <DesignSystemProvider>{element}</DesignSystemProvider>
  </CookiesProvider>
  // </VideoProvider>
);

export const onRouteUpdate = onRouteUpdateFn;

